module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-infiniti.701563cc.png";